import { ImageKeyUploadField } from "@/shared/ui/ImageKeyUploadField";

export const PROMOTION_IMAGE_KEY_PREFIX = "uploads/promotions";

export type PromotionImageUploadFieldProps = {
  value: string;
  onChange: (key: string) => void;
  pendingFile: File | null;
  onFileSelect: (file: File | null) => void;
  disabled?: boolean;
  label?: string;
};

export function PromotionImageUploadField({
  value,
  onChange,
  pendingFile,
  onFileSelect,
  disabled,
  label = "ຮູບໂປຣໂມຊັນ",
}: PromotionImageUploadFieldProps) {
  return (
    <ImageKeyUploadField
      value={value}
      onChange={onChange}
      keyPrefix={PROMOTION_IMAGE_KEY_PREFIX}
      label={label}
      deferUpload
      pendingFile={pendingFile}
      onFileSelect={(file) => onFileSelect(file ?? null)}
      onClear={() => {
        onFileSelect(null);
        onChange("");
      }}
      disabled={disabled}
      aspectRatio="aspect-4/3"
      aspectHint="4:3"
      widthPx={576}
      heightPx={288}
      className="w-full max-w-xl"
    />
  );
}
